import React from 'react';

const OutlineCloseIcon: React.FC = () => (
  <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="13" height="13" rx="6.5" fill="#E5E7EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.08914 7.00005L8.87782 5.21134C9.04073 5.04843 9.04073 4.7851 8.87782 4.62218C8.71491 4.45927 8.45159 4.45927 8.28868 4.62218L6.5 6.4109L4.71132 4.62218C4.54841 4.45927 4.28509 4.45927 4.12218 4.62218C3.95927 4.7851 3.95927 5.04843 4.12218 5.21134L5.91086 7.00005L4.12218 8.78876C3.95927 8.95168 3.95927 9.21501 4.12218 9.37792C4.20343 9.45917 4.31009 9.5 4.41675 9.5C4.52342 9.5 4.63008 9.45917 4.71132 9.37792L6.5 7.58921L8.28868 9.37792C8.36992 9.45917 8.47658 9.5 8.58325 9.5C8.68991 9.5 8.79657 9.45917 8.87782 9.37792C9.04073 9.21501 9.04073 8.95168 8.87782 8.78876L7.08914 7.00005Z"
      fill="#444444"
    />
  </svg>
);

export default OutlineCloseIcon;
